import { FormInputField, lt } from '@mews/framework';
import { ContentSection } from '@mews-commander/ui';
import { CancellationPolicyFormField } from '../types';
import { BookablePeriodSelectField } from './fields';

interface CancellationPolicyGeneralFormSectionProps {
    shouldDisableBookablePeriodField?: boolean;
    requireKeyField?: boolean;
}

export const CancellationPolicyGeneralFormSection = ({
    shouldDisableBookablePeriodField,
    requireKeyField = false,
}: CancellationPolicyGeneralFormSectionProps) => (
    <ContentSection title={lt('General')}>
        <FormInputField
            autoFocus
            name={CancellationPolicyFormField.Name}
            label={lt('Name')}
            helper={lt('CancellationPolicyFormNameFieldHelper')}
        />
        <FormInputField
            name={CancellationPolicyFormField.Key}
            label={lt('CancellationPolicyFormCancellationPolicyKeyFieldName')}
            helper={lt('CancellationPolicyFormCancellationPolicyKeyFieldHelper')}
            required={requireKeyField}
        />
        <BookablePeriodSelectField disabled={shouldDisableBookablePeriodField} />
    </ContentSection>
);
